import { ReactComponent as InfoIcon } from 'components/icons/info.svg';
import { ITeam } from 'interfaces/team/ITeam';
import React, { useEffect } from 'react';
import { ScheduledInfo, Team, Teams, Text, Versus } from './ScheduledGamePageStyles';

interface IProps {
  awayTeam: ITeam;
  homeTeam: ITeam;
  setIsPrivateGame: React.Dispatch<React.SetStateAction<boolean | null>>;
}

const ScheduledGamePage: React.FC<IProps> = (props) => {
  const { awayTeam, homeTeam, setIsPrivateGame } = props;

  useEffect(() => {
    // All scheduled game are official
    setIsPrivateGame(false);
  }, []);

  return (
    <div>
      <div>
        <Teams>
          <Team>{awayTeam.name}</Team>
          <Versus>vs</Versus>
          <Team>{homeTeam.name}</Team>
        </Teams>
        <ScheduledInfo>
          <InfoIcon />
          <Text>If the teams are not correct, please create a game and set the type to scheduled game</Text>
        </ScheduledInfo>
      </div>
    </div>
  );
};

export default ScheduledGamePage;
